<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../wrappedFetch.js";
    import Spinner from "./components/spinner.svelte";
    import Select from "./components/select.svelte";
    import Button from "./components/button.svelte";
    import DataTable from "../components/data-table.svelte";
    import HelpIcon from "./components/helpIcon.svelte";

    import { AuthUser } from "../store.js";

    export let providerId = 0;

    let titleProvider = providerId == 1 ? "Google" : providerId == 3 ? "Microsoft" : "";
    let isPageLoading = false;
    let schoolsForUser = $AuthUser.associatedSchools;
    let schoolsInMultiSync = [];
    let selectedSchool;
    // let trustOffice = $AuthUser.associatedSchools.find(school => (school.classify & 536870912) > 0);
    // let trustOfficeId = $AuthUser.schoolId;
    let multiSync;
    let showCreateButton = false;
    let askForMultiSyncName = false;
    let newMultiSyncName = '';
    let isCreateButtonLoading = false;
    let isAddButtonLoading = false;
    let order = [0, "asc"];
    let schoolsWithConfigs = [];

    onMount(async () => {
        isPageLoading = true;
        await GetMultiSync();
        if (multiSync != null)
        {
            await GetSchoolsInMultiSync();
            await AreConfigsSetupForMultiSyncSchools();
        }

        schoolsForUser = schoolsForUser.filter(s => s.schoolId != $AuthUser.schoolId);

        isPageLoading = false;

    });

    const GetMultiSync = async () => {
        let result = await wrappedFetch(
           // `/api/multiSync/GetMultiSync?providerId=${providerId}`,
           `/api/multiSync/GetMultiSyncForSchool?schoolId=${$AuthUser.schoolId}&providerId=${providerId}`,
           { method: "get" })
           .then( async (resp) => {
                multiSync = await resp.json();
            })
           .catch(() => { 
                showCreateButton = true;
                askForMultiSyncName = true; 
            });
    }

    const GetSchoolsInMultiSync = async () => {

        let result = await wrappedFetch(
           `/api/multiSync/GetSchoolsInMultiSync?multiSyncId=${multiSync.multiSyncId}`,
           { method: "get" });

        schoolsInMultiSync = await result.json();
    }

    const AreConfigsSetupForMultiSyncSchools = async () => {
        // console.log(multiSync)
        let result = await wrappedFetch(
           `/api/multiSync/AreConfigsSetupForMultiSyncSchools?multiSyncId=${multiSync.multiSyncId}&providerId=${providerId}`,
           { method: "get" })
           .then( async (resp) => {
                schoolsWithConfigs = await resp.json();
            });
           //.catch(() => { showCreateButton = true; } );
        //    console.log(schoolsWithConfigs);
    }

    const CreateMultiSyncForProvider = async () => {
        isCreateButtonLoading = true;

        let result = await wrappedFetch(
           `/api/multiSync/CreateMultiSync?schoolId=${$AuthUser.schoolId}&providerId=${providerId}&multiSyncName=${newMultiSyncName}`,
           { method: "post" }
       ).then(resp => resp.json())
       .catch(()=> isCreateButtonLoading = false);

       isCreateButtonLoading = false;
       showCreateButton = false;
    }

    const AddSchoolToMultisync = async () => {
       console.log(selectedSchool)
       isAddButtonLoading = true;

       let result = await wrappedFetch(
           `/api/multiSync/AddSchoolToMultiSync?multiSyncId=${multiSync.multiSyncId}&schoolId=${selectedSchool}&name=${schoolsForUser.find( s => s.schoolId == selectedSchool).estab}`,
           { method: "post" }
       ).then(resp => resp.json())
       .catch(()=> isAddButtonLoading = false);

       schoolsInMultiSync = [...schoolsInMultiSync, {multiSyncId: multiSync.multiSyncId, schoolId: selectedSchool, name: schoolsForUser.find( s => s.schoolId == selectedSchool).estab}];
       isAddButtonLoading = false;
   };

   const RemoveSchoolFromMultiSync = async (schoolId, index) => {
        console.log(schoolId, index)
        await wrappedFetch(
            `/api/multiSync/RemoveSchoolFromMultiSync?multiSyncId=${multiSync.multiSyncId}&schoolId=${schoolId}`,
            { method: "post" }
            );

        schoolsInMultiSync.splice(index, 1);
        schoolsInMultiSync = schoolsInMultiSync;
    }

    $: schoolsForUser = schoolsForUser.filter(s => schoolsInMultiSync.find(x => x.schoolId == s.schoolId) == null);

</script>

<h1>{titleProvider} MultiSync for {$AuthUser.establishment} </h1>
<p>Here you can add or remove schools to your {titleProvider} multi-sync.</p>

{#if isPageLoading}
    <Spinner />
{:else}

    {#if showCreateButton}
        <p>Multi-Sync for {titleProvider} does not exist for your establishment yet. Please click the button if you wish to create one.</p>
        <div class="form-group">
            <label for="multiSyncName" style="display:block;">What name do you want to use for your MultiSync?</label>
            <input type='text' style="border:1px solid #c4cdd5" bind:value={newMultiSyncName} />
            <Button
                bind:isLoading={isCreateButtonLoading}
                buttonClass={"btn-primary"}
                style="min-width:35px; vertical-align: top; "
                buttonText={"Create Multi-Sync"}
                disabled={newMultiSyncName == null || newMultiSyncName == ''}
                on:click={CreateMultiSyncForProvider}
            />
        </div>
    {:else}
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4">Select school:</div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4">
                        <Select id="schools"
                            bind:selected={selectedSchool}
                            width={100}
                            items={schoolsForUser}
                            value={'schoolId'}
                            label='estab'
                            placeholderText='school ' />
                    </div>
                    <div class="col-6 mt-3 mt-md-0">
                        <Button buttonText="Add School" buttonClass="btn-primary"
                            disabled={schoolsForUser.length < 1 || !selectedSchool || selectedSchool == '' } isConfirm={true}
                            popupTitle={"Confirmation"} popupText={"Are you sure you want to add this school to the multisync?"}
                            bind:isLoading={isAddButtonLoading}
                            on:click={() => console.log(selectedSchool)}
                            on:confirmPopup={AddSchoolToMultisync}
                        />
                    </div>
                </div>
            </div>
        </div>
        <hr/>

        <div class="row">
            <div class="col-12">
                <DataTable DataLength={schoolsInMultiSync.length} order={order} message={"There are no school in this MultiSync yet."}>
                    <thead>
                        <tr>
                            <th width="75%">Name</th>
                            <th width="25%">DFE-Code</th>
                            <th width="25%">Sync Configured?</th>
                            <th>Remove
                                <HelpIcon message="If a school already has a config set up then removing it from MultiSync would mean deleting the current configuration and setting it up from scratch again.
                                    If you wish to do so, please reach out to our support team." />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each schoolsInMultiSync as school,i}
                            <tr>
                                <td>{school.name}</td>
                                <td>{$AuthUser.associatedSchools.find( s => s.schoolId == school.schoolId)?.leaId}-{$AuthUser.associatedSchools.find( s => s.schoolId == school.schoolId)?.dfesId}</td>
                                <td>{schoolsWithConfigs.find(s => s.schoolId == school.schoolId)?.hasConfig == true ? 'Yes' : 'No'}</td>
                                <td>
                                    <Button
                                        buttonClass={"btn-grey"}
                                        style="min-width:35px; max-width:45px; vertical-align: top;"
                                        buttonText={"<i class='fa fa-times'></i>"}
                                        isConfirm={true}
                                        popupTitle={"Confirmation"} popupText={"Are you sure you want to remove this school from the multisync?"}
                                        disabled={schoolsWithConfigs.find(s => s.schoolId == school.schoolId)?.hasConfig == true}
                                        on:confirmPopup={RemoveSchoolFromMultiSync(school.schoolId, i)}
                                    />
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </DataTable>
            </div>
        </div>

        <!-- <Button
            buttonClass={"btn-primary"}
            title="Do we need a Save Changes button at the bottom or do we just do things on the go?"
            style="min-width:35px; vertical-align: top; float: right; "
            buttonText={"Save Changes? "}
        /> -->
    {/if}
{/if}
